

















































import { Component, Vue } from "vue-property-decorator";
import { User } from "@/api/user-api";
import AppHeader from "./AppHeader.vue";
import ChangePassword from "./ChangePassword.vue";
import SelectIcon from "./SelectIcon.vue";

@Component({
  components: {
    AppHeader,
    ChangePassword,
    SelectIcon
  }
})
export default class UserSettings extends Vue {
  get user(): User {
    return this.$store.state.user;
  }

  goHome() {
    this.$router.push("/");
  }

  saveProfile(e: Event) {
    const data = new FormData(e.target as HTMLFormElement);
    this.$store.dispatch("saveUserProfile", data);
  }
}
